import type { AvatarBackground, AvatarConfig, AvatarPattern } from '@super-mega/server/contracts/profile'

export const USER_AVATAR_PATTERNS = [
  'FACE_01',
  'FACE_02',
  'FACE_03',
  'FACE_04',
  'FACE_05',
  'FACE_06',
  'FACE_07',
  'FACE_08',
  'FACE_09',
  'FACE_10',
  'FACE_11',
  'FACE_12',
  'FACE_13',
  'FACE_14',
  'FACE_15',
  'FACE_16',
  'FACE_17',
  'FACE_18',
  'FACE_19',
  'FACE_20',
  'FACE_21',
  'FACE_22',
  'FACE_23',
  'FACE_24',
  'FACE_25',
  'FACE_26',
  'FACE_27',
  'FACE_28',
  'FACE_29',
  'FACE_30'
] as const satisfies readonly AvatarPattern[]

export const USER_AVATAR_BACKGROUNDS = [
  'MINT',
  'LIME',
  'TEAL',
  'CYAN',
  'SKY',
  'BLUE',
  'INDIGO',
  'VIOLET',
  'PURPLE',
  'FUCHSIA',
  'ROSE',
  'RED',
  'CORAL',
  'AMBER',
  'STONE',
  'SLATE'
] as const satisfies readonly AvatarBackground[]

export const DEFAULT_USER_AVATAR: AvatarConfig = {
  background: 'MINT',
  pattern: 'FACE_01'
}

export const USER_AVATAR_SEEDS: Record<AvatarPattern, string> = {
  FACE_01: 'super-mega-amelia',
  FACE_02: 'super-mega-avery',
  FACE_03: 'super-mega-bella',
  FACE_04: 'super-mega-caleb',
  FACE_05: 'super-mega-daisy',
  FACE_06: 'super-mega-elias',
  FACE_07: 'super-mega-freya',
  FACE_08: 'super-mega-hugo',
  FACE_09: 'super-mega-iris',
  FACE_10: 'super-mega-jules',
  FACE_11: 'super-mega-kai',
  FACE_12: 'super-mega-luna',
  FACE_13: 'super-mega-mason',
  FACE_14: 'super-mega-nora',
  FACE_15: 'super-mega-owen',
  FACE_16: 'super-mega-piper',
  FACE_17: 'super-mega-quinn',
  FACE_18: 'super-mega-ruby',
  FACE_19: 'super-mega-silas',
  FACE_20: 'super-mega-tessa',
  FACE_21: 'super-mega-uma',
  FACE_22: 'super-mega-vincent',
  FACE_23: 'super-mega-willow',
  FACE_24: 'super-mega-xavier',
  FACE_25: 'super-mega-yara',
  FACE_26: 'super-mega-zane',
  FACE_27: 'super-mega-astrid',
  FACE_28: 'super-mega-bodhi',
  FACE_29: 'super-mega-clara',
  FACE_30: 'super-mega-dorian'
}

export const USER_AVATAR_BACKGROUND_OPTIONS: Record<AvatarBackground, { color: string; label: string }> = {
  MINT: { color: 'd1fae5', label: '薄荷绿' },
  SKY: { color: 'e0f2fe', label: '天空蓝' },
  INDIGO: { color: 'e0e7ff', label: '靛青' },
  VIOLET: { color: 'ede9fe', label: '紫罗兰' },
  ROSE: { color: 'ffe4e6', label: '玫瑰粉' },
  CORAL: { color: 'ffedd5', label: '珊瑚橙' },
  AMBER: { color: 'fef3c7', label: '琥珀黄' },
  LIME: { color: 'ecfccb', label: '青柠绿' },
  TEAL: { color: 'ccfbf1', label: '青绿色' },
  SLATE: { color: 'e2e8f0', label: '雾灰色' },
  CYAN: { color: 'cffafe', label: '浅青色' },
  BLUE: { color: 'dbeafe', label: '湖蓝色' },
  PURPLE: { color: 'f3e8ff', label: '丁香紫' },
  FUCHSIA: { color: 'fae8ff', label: '木槿紫' },
  RED: { color: 'fee2e2', label: '樱桃红' },
  STONE: { color: 'e7e5e4', label: '暖灰色' }
}

export const DEFAULT_AVATAR_SIZE = 40
